export interface CartAddToken {
  s: string;
  i: number;
  n: string;
  t: number;
}

const TOKEN_MAX_AGE_MS = 10 * 60 * 1000;

function fromBase64Url(value: string): string {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  return atob(padded);
}

export function parseCartAddToken(token: string): CartAddToken | null {
  try {
    const decoded = fromBase64Url(token);
    const payload = JSON.parse(decoded) as CartAddToken;
    if (!payload.s || !payload.i || !payload.t) return null;
    if (Date.now() - payload.t > TOKEN_MAX_AGE_MS) return null;
    return payload;
  } catch {
    return null;
  }
}
